module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph card"
  }, [_c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticStyle: {
      "background-color": "#fff",
      "border": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/AquaWiz_trans_minimum.png"),
      "width": "110"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.serial != _vm.devname) ? _c('span', {
    staticStyle: {
      "font-size": "1.1em",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.s_number) + " " + _vm._s(_vm.devname))])]) : _c('span', {
    staticStyle: {
      "font-size": "1.1em",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.devname))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(30)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(365)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.row2csv()
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]))])])], 1), _vm._v(" "), (_vm.win_width > _vm.win_height) ? _c('line-graph', {
    staticStyle: {
      "position": "relative",
      "height": "90vh",
      "width": "100%"
    },
    attrs: {
      "chart-data": _vm.datacollection,
      "options": _vm.choptions
    }
  }) : _c('line-graph', {
    staticStyle: {
      "position": "relative",
      "height": "45vh",
      "width": "100%"
    },
    attrs: {
      "chart-data": _vm.datacollection,
      "options": _vm.choptions
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196993fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaRx_graph.vue
// module id = 520
// module chunks = 0